import { render, staticRenderFns } from "./SessionPrivateOffersInfo.vue?vue&type=template&id=4c052546&scoped=true&"
import script from "./SessionPrivateOffersInfo.vue?vue&type=script&lang=js&"
export * from "./SessionPrivateOffersInfo.vue?vue&type=script&lang=js&"
import style0 from "./SessionPrivateOffersInfo.vue?vue&type=style&index=0&id=4c052546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c052546",
  null
  
)

export default component.exports